<template>
  <div class="details">
    <div class="banner">
      <div class="publick centers">
        <div class="img fl"><img :src="info.avatar" width="105" height="105" alt=""></div>
        <div class="teacher fl">
          <h5>{{info.name}}</h5>
          <p class="p1">{{info.signature}}</p>
          <p class="p2">关注：{{info.focus_num}}</p>
        </div>
        <div @click="focus(1)" v-if="info.is_focus === 'NO' " class="button gz fr">关注</div>
        <div @click="focus(2)" v-if="info.is_focus === 'YES' " class="button zgz fr">取消关注</div>
      </div>
    </div>

    <div class="indexCourse">
      <ul class="publick">
        <li v-for="(item, index) in info.course" :key="index">
          <router-link :to="{ path: '/CourseDetails', query: { id: item.id }  }">
            <div class="img">
              <img :src="item.cover" width="287" height="175" alt="">
              <div class="hot">{{item.tag}}</div>
              <div class="label">
                <span v-for="(items, indexs) in item.level" :key="indexs">{{items.name}}</span>
              </div>
            </div>
            <div class="describe line-clamp-2">{{item.title}}</div>
            <div class="num">
              <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
              <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        id: '',
        info: []
      }
    },
    created () {
      this.$store.state.headindex = 99
      this.id = this.$route.query.id
      this.getData()
    },
    methods: {
      focus (type) {
        this.$http.post('/apipx/Lecturer/focus', {
          type: type,
          lecturer_id: this.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 2000
            })
            if (type === 1) {
              this.info.is_focus = 'YES'
            } else {
              this.info.is_focus = 'NO'
            }
          }
        })
      },
      getData () {
        this.$http.post('/apipx/Lecturer/info', {
          lecturer_id: this.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .details {

    .banner {
      width: 100%;
      height: 350px;
      background: url("banner.jpg") no-repeat center center;
      overflow: hidden;

      .centers {
        height: 107px;
        overflow: hidden;
        margin: 116.5px auto 0;

        .img {
          width: 107px;
          height: 107px;

          img {
            border-radius: 50%;
            border: 2px solid #fc968e;
          }
        }

        .teacher {
          margin: 0 0 0 30px;
          height: 107px;
          color: #fff;

          h5 {
            font-size: 24px;
            margin: 8px 0 0 0;
          }

          .p1 {
            margin: 10px 0 0 0;
            max-width: 800px;
          }

          .p2 {
            margin: 5px 0 0 0;
          }
        }

        .button {
          width: 130px;
          height: 50px;
          border-radius: 30px;
          text-align: center;
          line-height: 50px;
          font-size: 18px;
          margin: 28.5px 0 0 0;
          cursor: pointer;

          &.gz {
            background-color: #fff;
            color: #ff827b;
          }

          &.zgz {
            background-color: #ececec;
            color: #5c5c5c;
          }
        }
      }
    }

    .indexCourse {
      width: 100%;
      overflow: hidden;
      box-shadow: 0px 20px 20px -20px #f5f5f5;
      padding-bottom: 80px;
      margin-bottom: 50px;

      li {
        width: 287px;
        overflow: hidden;
        float: left;
        margin: 50px 17.3px 0 0;
        cursor: pointer;

        &:nth-child(4n) {
          margin-right: 0;
        }

        .img {
          width: 287px;
          height: 175px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;

          .hot {
            position: absolute;
            width: 50px;
            height: 35px;
            border-radius: 0 17.5px 17.5px 0;
            background-color: #fff;
            text-align: center;
            line-height: 35px;
            color: #fc8375;
            font-size: 14px;
            font-weight: bold;
            left: 0;
            top: 20px;
          }

          .label {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 20px;

            span {
              background-color: rgba(0, 0, 0, 0.5);
              color: #fff;
              padding: 5px 8px;
              border-radius: 10px;
              margin: 0 0 0 10px;
            }
          }
        }

        .describe {
          width: 287px;
          height: 50px;
          line-height: 25px;
          margin-top: 25px;
        }

        .num {
          height: 20px;
          width: 100%;
          font-size: 12px;
          color: #8f8f8f;
          margin-top: 10px;

          img {
            display: block;
            float: left;
          }

          .people {
            line-height: 20px;
            margin-right: 20px;

            img {
              margin: 3px 5px 0 0;
            }
          }

          .comment {
            line-height: 20px;

            img {
              margin: 5px 5px 0 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/teacher/details/details.vue